<template>
  <div class="forum-wrapper">
    <div v-if="writing" style="padding: 16px; height: 100%;">
      <ArticleWrite ref="writing" @submit="submit" @back="back"/>
    </div>
    <div v-else-if="browsing" style="padding: 16px; height: 100%;">
      <ArticleView :aID="browsing" @modify="modify" @back="back"/>
    </div>
    <div class="forum-body" v-else>
      <div class="forum-header">
        <input type="text" class="forum-title" @blur="nameUpdate()" v-model="name">
        <button class="button is-primary" @click="make()">新規作成</button>
        <button class="button close" @click="close()">閉じる</button>
      </div>
      <div class="article-list">
        <div v-for="(article, i) in forumArticles" :key="i"
          class="article" @click="view(article.id)">
          <div class="a-title">{{article.title}}</div>
          <div class="name">{{displayDate(article.updated_at) + '　　' + article.author_name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ArticleView from '@/views/DashBoard/VirtualOffice/Forum/ArticleView'
import ArticleWrite from '@/views/DashBoard/VirtualOffice/Forum/ArticleWrite'
import moment from 'moment'

export default {
  name: 'ForumBody',
  components: {
    ArticleView,
    ArticleWrite
  },
  computed: {
    ...mapState('virtualOffice', ['articles', 'openingForum']),
    forumArticles () {
      return this.articles.filter(a => a.forum == this.openingForum.id).sort((a,b) => {
        return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
      })
    }
  },
  data () {
    return {
      name: '',
      browsing: null,// 閲覧中の記事
      writing: false,// 編集中か否か
    }
  },
  mounted() {
    this.$store.dispatch('virtualOffice/getArticle')
    this.name = this.openingForum.name
  },
  methods: {
    nameUpdate () {
      let data = this.openingForum
      data.name = this.name
      this.$store.dispatch('virtualOffice/updateForum', data)
    },
    displayDate (d) {
      return moment(d).format('YYYY/MM/DD HH:mm')
    },

    view (id) {
      this.browsing = id
      this.writing = false
    },
    make () {
      this.browsing = null
      this.writing = true
      setTimeout(() => { this.$refs.writing.set(null) }, 1)
    },
    modify (id) {
      this.browsing = null
      this.writing = true
      let content = this.forumArticles.find(f => f.id == id)
      setTimeout(() => { this.$refs.writing.set(content) }, 1)
    },
    submit (content) {
      content.forum = this.openingForum.id
      if (content.id) this.$store.dispatch('virtualOffice/updateArticle', content)
      else this.$store.dispatch('virtualOffice/createArticle', content)
      this.writing = false
      this.browsing = content.id
    },
    del (id) {
      this.$store.dispatch('virtualOffice/deleteArticle', id)
    },
    back (id) {
      this.browsing = id
      this.writing = false
    },
    close () {
      this.$store.commit('virtualOffice/OPEN_FORUM', null)// close
    },
  }
}
</script>

<style scoped lang="scss">
.forum-wrapper {
  position: relative;
  text-align: left;
  height: 100%;
}
.forum-body {
  position: relative;
  height: 100%;
}
.forum-header {
  display: flex;
  height: 40px;
  margin: 16px;
  button {
    margin-left: 8px;
  }
}
.forum-title {
  width: 100%;
  font-size: 30px;
  font-weight: bold;
  border: none;
  background-color: white;
}
.close {
  width: 85px;
}
.article-list {
  height: calc(100% - 48px);
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  position: relative;
  padding: 16px;
}
.article {
  width: 100%;
  border: solid 2px silver;
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 8px;

  .a-title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .name {
    font-size: 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 4px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Forum/ForumBody.vue